// src/components/HandGenerator/index.js
import { useHandGenerator } from './useHandGenerator';
import { useBlastHandGenerator } from './useBlastHandGenerator';

export default useHandGenerator;
export { useHandGenerator };
export { useBlastHandGenerator };